import { borderRadius, margin, padding, styles, vw } from '@/common/style';
import { ImageStyle } from 'react-native';

export const Styles = {
    rowFlex: styles({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    }),
    columnFlex: styles({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }),
    bannerRow: {
        value: styles({
            // height: 90,
        }),
        image: styles({
            width: vw(100),
            height: 110,
            ...borderRadius(16, 16, 0, 0),
        }) as ImageStyle,
    },
    titleRow: {
        value: styles({
            ...padding(4, 19, 14),
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: '#fff',
            ...borderRadius(16, 16, 0, 0),
        }),
        title: styles({
            fontWeight: '700',
            fontSize: 18,
            color: 'rgba(0,0,0,0.88)',
        }),
        titleNew: styles({
            fontWeight: '500',
            fontSize: 16,
            color: 'rgba(0,0,0,0.88)',
            maxWidth: 184,
        }),
        titleNewBox: styles({
            flex: 1,
            alignItems: 'center',
            // 超出省略
            paddingRight: 16,
            flexDirection: 'row',
        }),
        head: styles({
            width: 42,
            height: 42,
            borderRadius: 21,
            marginRight: 12,
            borderWidth: 1,
            borderColor: 'rgba(0, 0, 0, 0.05)',
        }) as ImageStyle,
        descBox: styles({
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
        }),
        textBox: styles({
            flex: 1,
            flexDirection: 'row',
            alignItems: 'center',
        }),
        back: styles({
            marginRight: 4,
            width: 16,
            height: 16,
        }) as ImageStyle,
        soldNum: styles({
            height: 16,
            marginTop: 4,
            fontSize: 9,
            fontWeight: '500',
            color: 'rgba(255, 73, 6, 1)',
            backgroundColor: 'rgba(255, 73, 6, 0.12)',
            ...padding(0, 4),
            borderRadius: 3,
            marginRight: 4,
            maxWidth: 100,
            lineHeight: 16,
        }),
        productNum: styles({
            height: 16,
            marginTop: 4,
            fontSize: 9,
            fontWeight: '500',
            color: 'rgba(0, 0, 0, 0.4)',
            backgroundColor: 'rgba(200, 200, 200, 0.24)',
            ...padding(0, 4),
            borderRadius: 3,
            marginRight: 4,
            maxWidth: 100,
            lineHeight: 16,
        }),
        icon: styles({
            width: 24,
            height: 24,
        }) as ImageStyle,
        iconText: styles({
            fontWeight: '500',
            fontSize: 12,
            lineHeight: 15,
            color: 'rgba(0, 0, 0, 0.64)',
            minWidth: 45,
            textAlign: 'center',
        }),
        redPoint: styles({
            position: 'absolute',
            width: 7,
            height: 7,
            borderRadius: 100,
            backgroundColor: '#ff4906',
            top: 0,
            left: 15,
        }),
        rightCartRedDot: styles({
            backgroundColor: '#f00',
            fontWeight: '700',
            fontSize: 8,
            lineHeight: 9,
            color: '#fff',
            ...padding(2, 3.5),
            borderRadius: 6,
            top: -5,
            right: 0,
            overflow: 'hidden',
        }),
        miniRedDot: styles({
            width: 14,
            height: 14,
            lineHeight: 14,
            borderRadius: 7,
            textAlign: 'center',
            ...padding(0),
        }),
    },
    itemRow: {
        value: styles({
            ...padding(16, 19),
            height: 160,
            display: 'flex',
            flexDirection: 'column',
        }),
        infoRow: {
            imgInfoCol: {
                value: styles({
                    width: 128,
                    height: 128,
                    borderRadius: 7.5,
                    backgroundColor: '#f2f2f2',
                    marginRight: 12,
                }),
                topTipsView: styles({
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    fontSize: 15,
                    fontWeight: '700',
                    lineHeight: 18,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    ...padding(3.7, 7.5),
                    ...borderRadius(7.5, 0, 7.5, 0),
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 1,
                }),
                topTips: styles({
                    color: '#fff',
                    // backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    fontSize: 15,
                    fontWeight: '700',
                    lineHeight: 18,
                    // flexDirection: 'row',
                    // flexWrap: 'wrap',
                    // ...padding(3.7, 7.5),
                    // ...borderRadius(7.5, 0, 7.5, 0),
                    // position: 'absolute',
                    // top: 0,
                    // left: 0,
                    // zIndex: 1,
                }),
                firstBuy: styles({
                    backgroundColor: '#FFA038',
                }),
                explaining: {
                    value: styles({
                        display: 'flex',
                        width: '100%',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(0, 0, 0, 0.4)',
                        ...padding(3.7, 7.5),
                        ...borderRadius(7.5, 7.5, 0, 0),
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        zIndex: 1,
                    }),
                    image: styles({
                        width: 20,
                        height: 20,
                    }) as ImageStyle,
                    font: styles({
                        color: '#fff',
                        fontSize: 15,
                        lineHeight: 18,
                        fontWeight: '700',
                    }),
                },
                cover: {
                    value: styles({
                        width: 128,
                        height: 128,
                        borderRadius: 7.5,
                        position: 'relative',
                    }) as ImageStyle,
                    soldoutBox: styles({
                        width: 128,
                        height: 128,
                        position: 'absolute',
                        zIndex: 2,
                        backgroundColor: 'rgba(0, 0, 0, 0.48)',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 7.5,
                    }),
                    soldoutText: styles({
                        color: '#fff',
                        fontWeight: '500',
                        fontSize: 16,
                    }),
                },
                bottomTipsView: styles({
                    ...borderRadius(0, 0, 7.5, 7.5),
                    width: '100%',
                    height: 22,
                    backgroundColor: '#FF4906',
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    zIndex: 1,
                }),
                bottomTips: styles({
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    width: '100%',
                    // backgroundColor: '#FF4906',
                    color: '#fff',
                    fontSize: 13.7,
                    fontWeight: '500',
                    lineHeight: 16,
                    padding: 3,
                    ...borderRadius(0, 0, 7.5, 7.5),
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    zIndex: 1,
                }),
            },
            detailInfoCol: {
                value: styles({
                    flexGrow: 1,
                    width: 0,
                    height: 128,
                    // justifyContent: 'space-between',
                }),
                titleRow: styles({
                    fontSize: 14,
                    lineHeight: 16,
                    color: 'rgba(0, 0, 0, 0.88)',
                    flexWrap: 'wrap',
                }),
                tagsRow: styles({
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    flexGrow: 1,
                    alignContent: 'flex-start',
                    maxHeight: 44, // 超出两行隐藏
                    overflow: 'hidden',
                }),
                countDownTagItem: styles({
                    backgroundColor: 'rgba(200, 200, 200, 0.24)',
                    borderRadius: 3,
                    fontSize: 11,
                    lineHeight: 13,
                    height: 18,
                    color: 'rgba(0, 0, 0, 0.64)',
                    ...margin(4, 4, 0, 0),
                    ...padding(2.5, 4),
                }),
                tagItemView: styles({
                    backgroundColor: 'rgba(255, 73, 6, 0.12)',
                    borderRadius: 3,
                    fontSize: 11,
                    lineHeight: 13,
                    height: 18,
                    color: '#FF4906',
                    ...margin(4, 4, 0, 0),
                    ...padding(2.5, 4),
                }),
                addMoreTagItemView: styles({
                    backgroundColor: 'rgba(255, 73, 6, 0.12)',
                    borderRadius: 3,
                    fontSize: 11,
                    lineHeight: 13,
                    height: 18,
                    color: '#FF4906',
                    ...margin(4, 4, 0, 0),
                    ...padding(2.5, 4),
                    flexDirection: 'row',
                    alignItems: 'center',
                }),
                addMoreTagImage: styles({
                    width: 14,
                    height: 14,
                    borderRadius: 20,
                    marginRight: 4,
                }),
                tagItem: styles({
                    // backgroundColor: 'rgba(255, 73, 6, 0.12)',
                    // borderRadius: 3,
                    fontSize: 11,
                    lineHeight: 13,
                    height: 18,
                    color: '#FF4906',
                    // ...margin(4, 4, 0, 0),
                    // ...padding(2.5, 4),
                }),
                addMoreTagItem: styles({
                    fontSize: 11,
                    lineHeight: 18,
                    height: 18,
                    color: '#FF4906',
                }),
                tagCoin: {
                    box: styles({
                        height: 18,
                        display: 'flex',
                        flexDirection: 'row',
                        backgroundColor: 'rgba(255, 73, 6, 0.12)',
                        borderRadius: 3,
                        ...margin(4, 4, 0, 0),
                        ...padding(2.5, 4),
                    }),
                    coin: styles({
                        width: 14,
                        height: 14,
                        ...margin(0, 2),
                    }) as ImageStyle,
                    text: styles({
                        fontSize: 11,
                        lineHeight: 13,
                        color: '#FF4906',
                    }),
                },
                price: styles({
                    fontWeight: '700',
                    fontSize: 20,
                    lineHeight: 23,
                    color: '#ff4906',
                }),
                bottomRow: {
                    value: styles({
                        marginTop: 'auto',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-end',
                    }),
                    startPrice: {
                        label: styles({
                            fontWeight: '500',
                            fontSize: 11,
                            lineHeight: 13,
                            color: '#ff4906',
                        }),
                        price: styles({
                            maxWidth: 150,
                            marginTop: 2,
                            fontWeight: '700',
                            fontSize: 20,
                            lineHeight: 23,
                            color: '#ff4906',
                        }),
                    },
                    couponPrice: {
                        price: styles({
                            maxWidth: 150,
                            fontWeight: '700',
                            fontSize: 20,
                            lineHeight: 23,
                            color: '#ff4906',
                        }),
                        label: styles({
                            marginTop: 2,
                            fontWeight: '500',
                            fontSize: 12,
                            lineHeight: 14,
                            color: '#ff4906',
                        }),
                    },
                    guidePrice: {
                        guide: styles({
                            fontSize: 11,
                            lineHeight: 13,
                            color: '#999999',
                            textDecorationLine: 'line-through',
                            textDecorationColor: '#000',
                        }),
                        price: styles({
                            maxWidth: 150,
                            marginTop: 2,
                            fontWeight: '700',
                            fontSize: 20,
                            lineHeight: 23,
                            color: '#ff4906',
                        }),
                    },
                },
            },
            buyBtnCol: {
                needOpacity: styles({
                    opacity: 0.4,
                }),
                notNeedOpacity: styles({}),
            },
        },
    },
    actionBox: {
        wrap: styles({
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
        }),
        cartBtn: styles({
            width: 40,
            height: 32,
            marginRight: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 6,
        }),
        cartBtnWeak: styles({
            backgroundColor: 'rgba(247, 247, 247, 1)',
            borderWidth: 0,
        }),
        cartBtnDisabled: styles({
            opacity: 0.6,
        }),
        cartBtnIcon: styles({
            width: 24,
            height: 24,
        }) as ImageStyle,
        buyBtnWithCart: styles({
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
        }),
    },
    bottomTipsRow: {
        value: styles({
            ...margin(20, 19, 30, 19),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }),
        tip: styles({
            marginBottom: 20,
            fontSize: 14,
            color: 'rgba(156, 156, 156, 1)',
            textAlign: 'center',
        }),
        button: styles({
            height: 60,
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            ...padding(0, 12),
            alignItems: 'center',
            borderRadius: 8,
            backgroundColor: '#FFF6F3',
        }),
        buttonText: styles({
            fontSize: 14,
            fontWeight: '500',
            color: 'rgba(0, 0, 0, 0.88)',
            paddingRight: 12,
        }),
        goText: styles({
            fontSize: 14,
            fontWeight: '500',
            color: 'rgba(0, 0, 0, 0.88)',
        }),
        goButton: styles({
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
        }),
        back: styles({
            marginLeft: 12,
            width: 16,
            height: 16,
        }) as ImageStyle,
    },
};
